import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/Authentication/authentication.service';

@Component({
  selector: 'app-not-found',
  template: `<p>Redirecting...</p>`,
  standalone: true,
})
export class NotFoundComponent implements OnInit {
  constructor(private authService: AuthenticationService) {}

  ngOnInit() {
    if (this.authService.getAccessToken()) {
      this.authService.homePage();
    } else {
      this.authService.logout();
    }
  }
}
